import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';
import type { IconProps } from './Icon';

export const rootSx = (props: Partial<IconProps>): SystemStyleObject<Theme> => {
  let fontSize: number | 'inherit' = 24;
  if (props.fontSize === 'inherit') {
    fontSize = 'inherit';
  }
  if (props.fontSize === 'large') {
    fontSize = 32;
  }
  if (props.fontSize === 'small') {
    fontSize = 20;
  }

  return {
    display: 'inline-block',
    verticalAlign: 'middle',
    width: '1em',
    height: '1em',
    fontSize,
    fill: 'currentColor',
  };
};
